module.exports = __webpack_public_path__ + "static/img/logo_futian.6cd962b2.png";